import { LinearProgress } from "@material-ui/core";
import React from "react";

const LoadingScript = () => {
  return <LinearProgress />;
};

export default LoadingScript;
